import Pannellum from 'lib/pannellum';
import FloorplanManager from 'lib/service/e3.plan.manager';
import BlurAdmin from 'lib/blur/blur-admin'
import RenderZoneAdmin from 'lib/video-zone/video-zone-admin'
import Deffer from 'lib/helpers/deffer';
import {validURL, updateInfoIconStyle} from 'lib/helpers/common';
import { arrI, getIcon } from 'a_root-folder/infoicons/index';
import {updateWithMagick} from "lib/helpers/magick";
import E3Drag from "lib/helpers/draggable";

const debounce = require('lodash/debounce');
const throttle = require('lodash/throttle');
const blur = true;

class PannellumAdmin extends Pannellum {
    _draggingHotspot = false;
    _draggingFloorpoint = false;
    _waitingFloorpoint = false;
    _dragAdjustPoint = false;
    _floorpoints = [];
    _adjustTopPoint = false;
    _adjustPoints = {
        elements: [],
        coords: []
    };
    _adjustMode = {};
    _floorEditorMode = false;
    _adjustFloorpointsMode = false;
    _onDragFloorpointBound = this._onDragFloorpoint.bind(this);
    _onDragFloorpointFinishBound = this._onDragFloorpointFinish.bind(this);
    _baseVertice = null;
    _xmp = true;
    _imageData = null;
    _countDrawPoints = 3;
    _hs = {};
    _updatePositionPromise = null;
    _ghostPointRenderPromise = null;
    _hotspotTransitionActive = false;
    _drawing = false;
    _closeElement = [];
    _resetHotspotConfig = throttle((hs) => {
        E3Drag.enable(hs.div);
        hs.clicked = false;
    }, 700);

    static unbindFloorpointEvents(element) {
        E3Drag.destroy(element);
        element.style.touchAction = '';
    }

    _addAdjusmentPointPair(pairs) {
        if(!pairs || pairs.length !== 2) return ;

        let floor = pairs.map(p => p[0]);
        let ceil = pairs.map(p => p[1]);
        let {poseRoll, posePitch} = this._floorplan.getPoseData();
        let adjustPointBottom = FloorplanManager.getSpherCenter(...floor, poseRoll, posePitch);
        let adjustPointTop = FloorplanManager.getSpherCenter(...ceil, poseRoll, posePitch);

        this._adjustPoints.elements.push(this._createAdjustPoint());
        this._adjustPoints.coords.push([adjustPointBottom,adjustPointTop]);
    }

    _adjustPoint(index) {
        this._floorplan.lastDrownPointCorrection(index);
    }

    _lastDrownPointCorrection(pointIndex) {
        this._floorplan.lastDrownPointCorrection(pointIndex);
    }

    _animateHotspotTransition(hs, callback){
        E3Drag.disable(hs.div);
        this._fireEvent('animate-hotspot-transition', hs.sceneId);

        if(this._floorEditorMode) return this._animateHotspotTransitionWithFloorplan(hs, () => E3Drag.enable(hs.div));
        this._hotspotTransitionActive = true;

        if (this._floorEditorMode) return this._animateHotspotTransitionWithFloorplan(hs, () => {
            this._animateHotspotTransitionCallback(hs);
        });

        super._animateHotspotTransition(hs, () => {
            this._animateHotspotTransitionCallback(hs);
        });

        this._resetHotspotConfig(hs);
    }

    _animateHotspotTransitionCallback(hs) {
        E3Drag.enable(hs.div);

        this._hotspotTransitionActive = false;
    }

    _animateHotspotTransitionWithFloorplan(hs, callback){
        this._loadImageData(hs.sceneId);
        this.lookAt(hs.pitch, hs.yaw, 10, 700, () => {
            setTimeout(() => {
                this._loadSceneWithFloorplan(hs.sceneId, hs.targetPitch, hs.targetYaw, hs.targetHfov, () => {
                    if (this._orientation) this._startOrientation(true);
                });
                callback();
            }, 50);
        });
    }

    _loadImageData(sceneId){
        this._updatePositionPromise = Deffer();
        // this._current.hotSpots = this._current.hotSpots.filter((val) => val.type == 'scene');
        this._current.sceneId = sceneId;
        this._fireEvent('ongetimagedata', sceneId);
    }

    _loadSceneWithFloorplan(sceneId, pitch, yaw, hfov, callback = () => {}) {
        this._updatePositionPromise.promise.then(() => {
            super.loadScene(sceneId, pitch, yaw, hfov, () => {
                this.updateFloorplan(this._getFloorplanWithPreview());
                this.updatePointFromAutoPlan();
                this._fireEvent('scenechangeload', sceneId);
                callback();
            });
        })
    }

    isHotspotTransitionActive() {
        return this._hotspotTransitionActive
    }

    loadScene(sceneId, pitch, yaw, hfov, callback) {
        if(this._floorEditorMode || this._blurEditorMode){
            this._loadImageData(sceneId);
            this._loadSceneWithFloorplan(sceneId, pitch, yaw, hfov, callback);

            return ;
        }

        super.loadScene(sceneId, pitch, yaw, hfov, callback);

        return this;
    }

    getFloorplanWithPreview() {
        let plan = this.getPlan();
        plan.preview = this.getPlanPreview()

        return plan;
    }

    _getFloorplanWithPreview() {
        let plan = this.getPlan();
        plan.preview = this.getPlanPreview()

        return plan;
    }

    _bindAdjustPointEvents(element) {
        E3Drag.init(element,
            this._onDragAdjustPointStart.bind(this),
            this._onDragAdjustPoint.bind(this),
            this._onDragAdjustPointFinish.bind(this),
            () => {},
            {threshold: 1},
            this._onMouseDowndAjustPoint.bind(this)
        );
        element.style.touchAction = 'none';

    }

    _bindFloorpointEvents(element) {
        E3Drag.init(element,
            () => {},
            this._onDragFloorpointBound,
            this._onDragFloorpointFinishBound,
            this._onTapFloorpoint.bind(this, element),
            {threshold: 4}
        );
        element.style.touchAction = 'none';
    }

    _continueInteracting(eventObjects) {
        if(this._waitingFloorpoint && !this._isUserInteracting && !this._draggingFloorpoint && !this._draggingHotspot && this._floorplan._layerId) {
            if(eventObjects[0].target === this._dragFix) {
                let [pitch, yaw] = this._mouseEventToCoords(eventObjects[0]);
                this._floorplan.setGhostPoint([yaw, pitch]);
            }
            else {
                this._floorplan.removeGhostPoint();
            }

            if (!this._renderer.isLoading()) requestAnimationFrame(this._animateBound);
        }

        this._fireEvent('continue-interacting', eventObjects);

        super._continueInteracting(eventObjects);
    }

    _createAdjustPoint() {
        let bottomElem = document.createElement('div');
        bottomElem.className = `pnlm-floorpoint pnlm-adjust-point`;

        let topElem = document.createElement('div');
        topElem.className = `pnlm-floorpoint pnlm-adjust-point`;

        this._bindAdjustPointEvents(topElem);
        this._bindAdjustPointEvents(bottomElem);

        this._renderContainer.appendChild(bottomElem);
        this._renderContainer.appendChild(topElem);
        return [bottomElem, topElem];
    }

    _createFloorplanPoint(classname) {
        classname = !classname ? '' : classname;
        let elem = document.createElement('div');
        elem.className = `pnlm-floorpoint ` + classname;

        this._bindFloorpointEvents(elem);

        this._renderContainer.appendChild(elem);
        return [elem];
    }

    _createFloorplanPoints() {
        let vertexCount = this._floorplan.getVertexCount();
        for(let i = 0 ; i < vertexCount; i++) {
            this._floorpoints.push(this._createPoints());
            if (i > 0) {
                this._adjustPoints.elements.push(this._createAdjustPoint());

                if (i+1 === vertexCount) {
                    this._adjustPoints.elements.push(this._createAdjustPoint());
                }
            }
        }

        this._recalculateAdjustPoints();
        this._renderFloorplanPoints();
    }

    _createHotSpot(hs, ind) {
        super._createHotSpot(hs, ind);
        if(this._stateListening) {
            this._disableHotspotsDrag([hs]);
            if(hs.type === 'info') hs.div.classList.add('disabled');
        }
    }

    removeArea(areaID) {
        this._floorplan.removeArea(areaID);
    }

    _createHotSpots() {
        super._createHotSpots();
    }

    _createPoints(classname) {
        classname = !classname ? '' : classname;
        let bottomElem = document.createElement('div');
        bottomElem.className = `pnlm-floorpoint ` + classname;

        let topElem = document.createElement('div');
        topElem.className = `pnlm-floorpoint ` + classname;

        this._bindFloorpointEvents(topElem);
        this._bindFloorpointEvents(bottomElem);

        this._renderContainer.appendChild(bottomElem);
        this._renderContainer.appendChild(topElem);
        return [bottomElem, topElem];
    }

    _createSceneElements() {
        super._createSceneElements();
        if(this._floorEditorMode) {
            this._createFloorplanPoints();
        }
    }

    _destroyFloorplanPoint(index) {
        let adjustIndex = index ? index - 1 : this._adjustPoints.elements.length - 1;
        this._floorpoints.splice(index, 1)[0].forEach(el => {
            PannellumAdmin.unbindFloorpointEvents(el);
            el.parentNode.removeChild(el);
        });
        if (!!~adjustIndex && this._adjustPoints.elements.length > 0 && this._adjustPoints.elements.length > adjustIndex) {
            this._adjustPoints.elements.splice(adjustIndex, 1)[0].forEach(el => {
                PannellumAdmin.unbindFloorpointEvents(el);
                el.parentNode.removeChild(el);
            });
            this._adjustPoints.coords.splice(adjustIndex, 1);
        }
    }

    _destroyFloorplanPoints() {
        while(this._floorpoints.length) {
            this._destroyFloorplanPoint(this._floorpoints.length - 1);
        }
    }

    _destroyHotSpots() {
        super._destroyHotSpots();
        this._destroyFloorplanPoints();
    }

    destroy(){
        this._fireEvent('destroy')
        super.destroy();
        // this._floorplan.destroy();

    }

    _disableHotspots(hotspots){
        (hotspots || this._current.hotSpots).forEach(hs => E3Drag.disable(hs.div));
    }

    _disableHotspotsDrag(hotspots) {
        (hotspots || this._current.hotSpots).forEach(hs => E3Drag.enableDrag(hs.div));
    }

    _enableHotspots(hotspots){
        (hotspots || this._current.hotSpots).forEach(hs => E3Drag.enable(hs.div));
    }

    _enableHotspotsDrag(hotspots) {
        (hotspots || this._current.hotSpots).forEach(hs => E3Drag.disableDrag(hs.div));
    }

    // _renderInteractingForFindPose(yaw, pitch, classname) {
    //     this._floorplan.addPrerenderPoint([yaw, pitch]);
    //     this._floorpoints.push(this._createFloorplanPoint(classname));
    //
    //     if(this._floorplan.getVertexCount() > this._countDrawPoints){
    //         this._xmp = false;
    //         this._floorplan.adjustPointsOnBaseOf();
    //         let vertices = this._floorplan._vertices.slice();
    //         this._fireEvent('set.details', false);
    //         this._destroyFloorplanPoints();
    //         this._floorplan.removeVertices();
    //         this._floorplan.removeGhostPoint();
    //         vertices.splice(1,2);
    //         vertices.forEach((val, ind) => {
    //             let [yaw, pitch] = val.floorEqui.map(v => v / FloorplanManager.radian);
    //             this._floorplan.addPoint([yaw, pitch]);
    //             this._floorpoints.push(this._createPoints(classname));
    //         });
    //         let pairs = this._floorplan.getVerticesSpherCoords().filter((p,i,arr) => arr.length - i <= 2);
    //         this._addAdjusmentPointPair(pairs);
    //     }
    // }

    // _mouseEventToCoords(event) {
    //     let [pitch, yaw] = super._mouseEventToCoords(event, true);
    //
    //     ([yaw, pitch] = this._applyCameraCorrection(yaw, pitch));
    //
    //     return [pitch / Pannellum.RADIAN, yaw / Pannellum.RADIAN]
    // }

    // _renderHotSpotElement(yaw, pitch, element, titleElement) {
    //     let [_yaw, _pitch, _roll] = this._applyCameraCorrection();
    //
    //     let hsPitchSin = Math.sin(pitch * Pannellum.RADIAN),
    //         hsPitchCos = Math.cos(pitch * Pannellum.RADIAN),
    //         configPitchSin = Math.sin(_pitch),
    //         configPitchCos = Math.cos(_pitch),
    //         yawCos = Math.cos((-yaw) * Pannellum.RADIAN + _yaw);
    //     let z = hsPitchSin * configPitchSin + hsPitchCos * yawCos * configPitchCos;
    //     if (z <= 0 && ((yaw <= 90 && yaw > -90) || (yaw > 90 || yaw <= -90))) {
    //         element.style.visibility = 'hidden';
    //     } else {
    //         let [canvasWidth, canvasHeight] = this._renderer.getCanvasDimensions();
    //         // let aspect = canvasWidth / canvasHeight;
    //         let hfovRes = this._normalizeHfov(this._current.hfov, canvasWidth / canvasHeight);
    //         let hfov = hfovRes[0] ? hfovRes[1] / Pannellum.RADIAN : this._current.hfov;
    //         let hfovRad = hfovRes[0] ? hfovRes[1] : this._current.hfov * Pannellum.RADIAN;
    //         let yawSin = Math.sin((-yaw) * Pannellum.RADIAN + _yaw),
    //             hfovTan = Math.tan(hfovRad / 2);
    //         element.style.visibility = 'visible';
    //
    //         // Subpixel rendering doesn't work in Firefox
    //         // https://bugzilla.mozilla.org/show_bug.cgi?id=739176
    //         canvasWidth /= window.devicePixelRatio || 1;
    //         canvasHeight /= window.devicePixelRatio || 1;
    //         let coord = [-canvasWidth / hfovTan * yawSin * hsPitchCos / z / 2,
    //             -canvasWidth / hfovTan * (hsPitchSin * configPitchCos -
    //                 hsPitchCos * yawCos * configPitchSin) / z / 2];
    //         // Apply roll
    //         let rollSin = Math.sin(_roll),
    //             rollCos = Math.cos(_roll);
    //         coord = [coord[0] * rollCos - coord[1] * rollSin,
    //             coord[0] * rollSin + coord[1] * rollCos];
    //         // Apply transform
    //         coord[0] += canvasWidth >> 1;
    //         coord[1] += canvasHeight >> 1;
    //         let scaleSize = this._getHotspotScale(hfov);
    //         transform.transform(
    //             element,
    //             coord[0],
    //             coord[1],
    //             9999,
    //             scaleSize,
    //             element.classList.contains('hotspot-zoomable')
    //                 ? `rotate3d(1, 0, 0, ${-_pitch / Pannellum.RADIAN + 90}deg) rotate3d(0, 0, 1, ${_yaw / Pannellum.RADIAN}deg)`
    //                 : this._current.roll
    //         );
    //         element.dataset['scale'] = scaleSize;
    //
    //         //TODO: check if works without querying DOM
    //         // let span = element.querySelector('.pnlm-hotspot-title');
    //         if (titleElement) {
    //             if (!transform.supported) {
    //                 if (!titleElement.dataset.width) {
    //                     titleElement.dataset.width = titleElement.offsetWidth || titleElement.clientWidth;
    //                     titleElement.style.marginLeft = -(titleElement.dataset.width / 2) + 'px';
    //                     titleElement.style.top = '-30px';
    //                 }
    //             }
    //             else {
    //                 transform.transform(titleElement, '-50%', -10 - 15 / scaleSize, null, 1 / scaleSize, 0);
    //             }
    //         }
    //     }
    // }

    _finishInteracting(eventObjects) {
        if(!this._isUserInteracting) {
            super._finishInteracting(eventObjects);
            return;
        }
        let classname = !this._floorplan.getVertexCount() ? 'last-floorpoint' : '';
        if (this._waitingFloorpoint) {
            let {x, y} = this._mousePosition(eventObjects[0]);
            let dx = x - this._interactionData.x;
            let dy = y - this._interactionData.y;
            if(Math.sqrt(dx * dx + dy * dy) < 4) {
                let [pitch, yaw] = this._mouseEventToCoords(eventObjects[0]);
                this._renderInteracting(yaw, pitch, classname);
                this._render();
                this._fireEvent('floorpoint.add', {point: [yaw, pitch], count: this._floorplan.getVertexCount()});
            }
        }

        this._fireEvent('finish-interacting', {eventObjects, classname});
        super._finishInteracting(eventObjects);
    }

    _getRenderParams(screenshotFormat) {
        let params = super._getRenderParams(screenshotFormat);

        if (this._floorEditorMode) {
            Object.assign(params, {
                e3plan: this._floorplan.getCubeVertices()
            });
        }

        this._fireEvent('get-render-params', params);

        return params;
    }

    _initFloorplan(config, isInit = false, title) {
        this._floorplan = new FloorplanManager(config, {
            scenes: Object.keys(this._initialConfig.scenes).map(id=>({
                id: this._initialConfig.scenes[id].id,
                name: this._initialConfig.scenes[id].name,
                hotSpots: this._initialConfig.scenes[id].hotSpots,
                panorama: this._initialConfig.scenes[id].panorama

            })),
            init: isInit
        }, title);
    }

    updateScenePreview() {
        return this._floorplan.updateScenePreview(this._initialConfig.scenes);
    }

    setChangePreview(value) {
        return this._floorplan.setChangePreview(value);
    }

    isUpdatePreviewNeeded() {
        return this._floorplan.isUpdatePreviewNeeded();
    }

    /**
     * Checks if hs container has POI editor
     * !!! pay attention on classNames when checking if info editor is opened
     * @param hs - hotspot
     * @private
     */
    _checkInfoHS(hs) {
        return hs.type === 'info' &&
            hs.div.querySelector('.show-info-editor #e3-poi-editor');
    }

    _initHotspotEvents(hs){
        if(['scene', 'info'].indexOf(hs.type) > -1) {
            E3Drag.init(
                hs.div,
                () => {
                    if (this._checkInfoHS(hs)) return;

                    this._draggingHotspot = true;
                    this._fireEvent('hotspotdragstart');
                },
                (elem, pageX, pageY) => {
                    if (this._checkInfoHS(hs)) return;
                    this._onDragHotspot(hs.span, elem, pageX, pageY, hs);
                },
                (elem, pageX, pageY) => {
                    if (this._checkInfoHS(hs)) return;

                    let coords = this._mouseEventToCoords({
                        clientX: pageX,
                        clientY: pageY
                    });

                    this._fireEvent('hotspotdrag', hs.lineID || hs.id, coords[0], coords[1], hs.pitch, hs.yaw, hs.type);
                    hs.pitch = coords[0];
                    hs.yaw = coords[1];
                    this._floorplan.updateHotspot(hs.id, [hs.yaw, hs.pitch]);
                    this._renderHotSpot(hs);
                    this._draggingHotspot = false;
                    this._fireEvent('preview');
                },
                (e) => {
                    if (this._waitingFloorpoint || this._waitingBlurpoint || this._checkInfoHS(hs)) return;

                    if (hs.type === 'scene') hs = this.updateHotspotValue(hs);

                    this._onHotspotTap(hs, e);
                }, {
                    threshold: 'default'
                },
                () => Promise.resolve(),
                (e) => {
                    return new Promise((res, rej) => {
                        if (hs.type === 'info') return res();
                        this._draggingHotspot = true;
                        res();
                    })
                }
            );

            hs.div.style.touchAction = 'none';
            if(!this._initialConfig.editable)  E3Drag.disableDrag(hs.div);
        }

        // if (hs.type === 'scene') {
        //     this._initHotspotTooltip(hs)
        // }
    }

    // _initHotspotTooltip(hs) {
    //     let {id} = hs;
    //     let src = 'https://eyespy360-dev5.s3.amazonaws.com/u/a456b820-c55e-11e8-8724-931000dd7033/m/thumbnail.jpg';
    //     this._hotspotTooltip.add(id, hs.div, src);
    // }
    //
    // _destroyHotspotTooltip(hs) {
    //     let {id} = hs;
    //     this._hotspotTooltip.remove(id);
    // }


    updateHotspotValue(hs) {
        let scenes = Object.values(this._initialConfig.scenes);
        for (let i = 0; i < scenes.length; i++) {
            if (!scenes[i].hotSpots) {
                continue;
            }
            for (let j = 0; j < scenes[i].hotSpots.length; j++) {
                if (scenes[i].hotSpots[j].lineID == hs.lineID && scenes[i].hotSpots[j].sceneId == hs.sceneId) {
                    hs.targetYaw = scenes[i].hotSpots[j].targetYaw;
                    hs.targetPitch = scenes[i].hotSpots[j].targetPitch;
                    hs.targetHfov = scenes[i].hotSpots[j].targetHfov;
                    break;
                }
            }
        }

        return hs;
    }

    updateInitialHotspots(config) {
        for(let i in this._initialConfig.scenes){
            for(let j in config.scenes){
                if(j == i){
                    this._initialConfig.scenes[i].hotSpots = config.scenes[j].hotSpots;
                }
            }
        }
    }

    _isActionKeyDown(keys) {
        if(this._draggingHotspot) return false;
        return super._isActionKeyDown(keys);
    }

    _mergeConfig(sceneId) {
        super._mergeConfig(sceneId);

        // this._current.hotSpots = this._current.hotSpots.filter((val) => val.type === 'scene');
        this._current.sceneId = sceneId;
    }

    _onDragAdjustPoint(element, px, py) {
        if(!this._dragAdjustPoint) return ;
        let [pitch, yaw] = this._mouseEventToCoords({
            clientX: px,
            clientY: py
        });

        if (this._adjustMode.coords[1] * pitch <= 0) return;

        let index = this._adjustPoints.elements.findIndex(elPair => elPair.includes(element));

        if (!~index) return;
        let oppositePoint = this._adjustPoints.coords[index].find(p => p[1] * pitch <= 0)
        if(oppositePoint){
            oppositePoint = oppositePoint.map(c=>c/Pannellum.RADIAN);
            pitch *= 1 + Math.abs(pitch / 90);
            let newPitchRatio = pitch < 0 ? oppositePoint[1] / -pitch : pitch / -oppositePoint[1];
            this._floorplan.setCeilingHeight(newPitchRatio, pitch > 0);
        }
        this._recalculateAdjustPoints();
        this._adjustTopPoint = pitch > 0;
        this._render();
    }

    _onDragAdjustPointFinish() {
        if(!this._dragAdjustPoint){
            this._dragAdjustPoint = true;
            return ;
        }
        this._adjustMode = {
            enable: false,
            coords: []
        }
        this._fireEvent('floorplan.edit.details', this._adjustTopPoint);
    }

    _onMouseDowndAjustPoint() {
        return new Promise((res, rej) => {
            let plan  = this.getPlanPreview();
            if(!this.isDrawingFinished && !plan.customUpdate) {
                this._recreateFloorplan()
                    .then(() => {
                        this._dragAdjustPoint = false;
                        res();
                    })
                    .catch(() => {
                        this._draggingHotspot = false;
                        rej('floorplan will not ber recreate');
                    })
            }else if(plan.customUpdate){
                this._dragAdjustPoint = false;
                res();
            }
        })
    }

    recreateFloorplan(showMsg = false){
        return this._recreateFloorplan(showMsg);
    }

    _recreateFloorplan(showMsg = false){
         return new Promise((res, rej) => {
             let plan  = this.getPlanPreview();
             if (this._floorplan && (showMsg && plan.customUpdate) && !window.confirm("Your floorplan will be recreated, do you want to proceed?")) {
                 rej();
             }else{
                 plan.customUpdate = false;
                 this.setPlanPreview(plan);
                 this._fireEvent('preview');
                 res()
             }
         })
    }

    /**
     * Custom changes debounce.
     * @private
     */
    _customChangesDebounce() {
        if (!this._debounceCustomChanges) {
            this._debounceCustomChanges = debounce(()=> {
                this._customChanges = false;
            }, 5000)
        }
        this._customChanges = true;
        this._debounceCustomChanges();
    }

    recreateCurrentFloor(){
        return this._recreateCurrentFloor();
    }

    _recreateCurrentFloor() {
        return new Promise((res, rej) => {
            if(this.getVertexCount() === 0 || this._customChanges) return res();
            const plan = this.getPlanPreview();

            if (plan.customUpdate && !window.confirm("Your floorplan for this image will be recreated, do you want to proceed?")) {
                this._customChanges = false;
                rej();
            }else{
                this._customChangesDebounce();
                res()
            }
        })
    }

    _unSelectHole() {
        let plan = this.getPlanPreview();
        let layers  =  Object.values(plan.layers);
        layers.forEach((layer) => {
            const holes = Object.values(layer.holes);
            holes.forEach(hole => hole.selected = false);

            layer.selected.holes = [];
        })
        this.setPlanPreview(plan);
    }

    _updateCustomUpdateField(status) {
        let plan  = this.getPlanPreview();
        console.log('_updateCustomUpdateField', status)
        plan.customUpdate = status;
        // plan.customUpdate = true;
        this.setPlanPreview(plan);
    }

    _onDragAdjustPointStart(element) {
        this._fireEvent('floorpoint.start.adjust', {});
        this._dragAdjustPoint = true;
        let {left: x, top: y} = element.getBoundingClientRect();
        let [pitch, yaw] = this._mouseEventToCoords({
            clientX: element.offsetWidth / 2 + x,
            clientY: element.offsetHeight / 2 + y
        }).map(c => c * Pannellum.RADIAN);
        this._adjustMode.enable = true;
        this._adjustMode.coords = [yaw, pitch];
        this._adjustMode.client = [element.offsetWidth / 2 + x, element.offsetHeight / 2 + y];
    }

    setCeilling(height) {
        return this._floorplan.setCeilling(height);
    }

    updateScenePanorama(params) {
        return this._floorplan.updateScenePanorama(params);
    }

    _onDragFloorpoint(element, px, py) {
        if(this._floorplan.isDrawingFinished()) return;
        this._draggingFloorpoint = true;

        let [pitch, yaw] = this._mouseEventToCoords({
            clientX: px,
            clientY: py
        });
        let index = this._floorpoints.findIndex(elPair => elPair.includes(element));
        this._floorplan.updateVertexView([yaw,pitch], index, this._adjustFloorpointsMode, this._floorpoints[index][0] === element);
        this._recalculateAdjustPoints();
        this._render();
    }

    _onDragFloorpointFinish(element, pageX, pageY) {
        this._onDragFloorpoint(element, pageX, pageY);
        let index = this._floorpoints.findIndex(elPair => elPair.includes(element));
        this._floorplan.removeVertexSnapData(index);
        this._draggingFloorpoint = false;
    }

    _onDragHotspot(titleElement, elem, px, py, hs) {
        let coords = this._mouseEventToCoords({
            clientX: px,
            clientY: py
        });

        // needed to set coords to hotspot while dragging
        // prevents "frizzing" hotspot while dragging during scene images loading
        if (hs) {
            hs.pitch = coords[0];
            hs.yaw = coords[1];
        }

        this._renderHotSpotElement(coords[1], coords[0], elem, titleElement);
        this._render();
        return coords;
    }

    _onKeyChangeOff() {
        super._onKeyChangeOff();
        this._enableHotspots();
    }

    _onKeyChangeOn() {
        super._onKeyChangeOn();
        this._disableHotspots();
    }

    _onTapFloorpoint(element) {
        if(this._floorplan.isDrawingFinished()) return;

        let index = this._floorpoints.findIndex(elPair => elPair.includes(element));

        if(index > 0) return;

        // move last point to right place on plan (to be 90 deg with 1st one)
        this._floorplan.lastDrownPointCorrection(this._floorpoints.length - 1);
        this._floorpoints[0].forEach((val) => val.classList.remove('last-floorpoint'));

        this._removePointOnSameLine();
        let vertices = this._floorplan.getVerticesSpherCoords();

        let last = vertices.length - 1;
        let pairs = [vertices[0], vertices[last]];
        this._addAdjusmentPointPair(pairs);

        this._floorplan.closePath();

        this._render();
        // this._updateCustomUpdateField(false);
        this._fireEvent('preview');
        this._fireEvent('floorplan.edit.finish', false);
        this.isDrawingFinished = false;
    }

    _removePointOnSameLine(){
        let vertices = this._floorplan.getVerticesSpherCoords();
        const removePoints = [];
        let keysVertices =  Object.keys(vertices);

        keysVertices.reduce((prev,current, i, arr) => {
            const angle = this._floorplan.checkSnapVertex(Number(prev),  Number(current));

            if((angle > 176 && angle < 185)  || isNaN(angle)){
                this._destroyFloorplanPoint(current);
                this._floorplan.removeVertice(current);

                this._removePointOnSameLine();
                arr.splice(1);
            }

            return current;
        }, keysVertices[keysVertices.length-1]);

        this._recalculateAdjustPoints();
    }

    _prepareInitialConfig(initialConfig) {
        if(blur) {
            this._addBlurListener();
        }
        this._renderZoneManager = new (require('lib/video-zone/service').default)();
        this._addRenderZoneListeners();
        super._prepareInitialConfig(initialConfig);
        this._currentSceneId = Number(initialConfig.default.firstScene);
        this._initFloorplan(this._initialConfig.e3plan, true, this._initialConfig.title);
        this._fireEvent('prepare-initial-config', initialConfig);

        // Mutate hotspots between Pannellum and  input config (from tourJS)
        this.updateInitialHotspots(initialConfig);
    }

    _addPoints(layout) {
        console.log('adding processed points:', layout);

        layout.uv.filter((p, i) => i % 2)
            .map(p => ([FloorplanManager.xToYaw(p[0]), FloorplanManager.yToPitch(p[1])]))
            .forEach(p => {
                this._renderInteracting(p[0], p[1]);
                this._fireEvent('floorpoint.add', {point: p, count: this._floorplan.getVertexCount()});
            });

        this._floorplan.closePath();
        this._render();
        this._updateCustomUpdateField(false);
        this._fireEvent('preview');
        this.setChangePreview(true);
        this._fireEvent('floorplan.edit.finish', true);
        this.isDrawingFinished = false;
    }

    // "Detect room" (lib/floorplan-detect): replace the current room's corners
    // with a model's layout — same format as the image layout_json. Drawn like
    // the auto layout on load (_addPoints): a finished, closed room.
    applyLayout(layout) {
        if (!layout || !layout.uv || layout.uv.length < 6) return;
        // clearPoints() alone keeps the area's vertices — the new corners would be appended
        if (this._floorplan.getVertexCount() > 0) this.clearArea();
        this.clearPoints();
        this._addPoints(layout);
    }

    getScenePanorama(sceneId = this.getScene()) {
        const scene = this._initialConfig && this._initialConfig.scenes && this._initialConfig.scenes[sceneId];
        return scene ? scene.panorama : null;
    }

    updatePointFromAutoPlan() {
        if(!this._imageData.layout_json) return ;

        if (this._floorplan.getVertexCount() === 0) {
            this.clearPoints();
            this._addPoints(JSON.parse(this._imageData.layout_json));
        }
    }

    updatePosition(image_data) {
        this._imageData = image_data;
        this._fireEvent('update-position', image_data);

        if(!this._floorplan) return ;

        if(!this._updatePositionPromise){
            this.updateFloorplan(this._getFloorplanWithPreview());
        }else{
            this._updatePositionPromise.resolve();
        }
    }

    updatePreview() {
        this._floorplan.updatePreview();
    }

    _setCameraCorrection(posePitch = null, poseRoll = null){
        if(!this._imageData || !this._imageData.xmp) return [0, 0];
        if(posePitch === null || poseRoll === null){
            this._xmp = this._parseXmp(this._imageData.xmp);
            this._current.posePitchDegrees = this._xmp.posePitchDegrees >= -90 && this._xmp.posePitchDegrees <= 90 ? this._xmp.posePitchDegrees : 0
            this._current.poseRollDegrees = this._xmp.poseRollDegrees >= -90 && this._xmp.poseRollDegrees <= 90 ? this._xmp.poseRollDegrees : 0
        }

        posePitch = this._current.posePitchDegrees * Math.PI / 180;
        poseRoll = this._current.poseRollDegrees * Math.PI / 180;

        return [posePitch, poseRoll];
    }

    _parseXmp(xmpData) {
        let PosePitchDegrees = null,
            PoseHeadingDegrees = null,
            CroppedAreaTopPixels = null,
            CroppedAreaImageHeightPixels = null,
            FullPanoHeightPixels = null,
            CroppedAreaImageWidthPixels = null,
            fullWidth = null,
            PoseRollDegrees = null;

        recursiveCheckData(xmpData);
        function recursiveCheckData(xmpData){
            for(let val in xmpData){
                if(val.match(/PosePitchDegrees/g)) PosePitchDegrees = Number(xmpData[val]);
                if(val.match(/PoseRollDegrees/g)) PoseRollDegrees = Number(xmpData[val]);
                if(val.match(/PoseHeadingDegrees/g)) PoseHeadingDegrees = Number(xmpData[val]);
                if(val.match(/CroppedAreaTopPixels/g)) CroppedAreaTopPixels = Number(xmpData[val]);
                if(val.match(/CroppedAreaImageHeightPixels/g)) CroppedAreaImageHeightPixels = Number(xmpData[val]);
                if(val.match(/FullPanoHeightPixels/g)) FullPanoHeightPixels = Number(xmpData[val]);
                if(val.match(/CroppedAreaImageWidthPixels/g)) CroppedAreaImageWidthPixels = Number(xmpData[val]);
                if(val.match(/fullWidth/g)) fullWidth = Number(xmpData[val]);

                if(typeof xmpData[val] === 'object') recursiveCheckData(xmpData[val]);
            }
        }

        return {
            fullWidth: fullWidth,
            croppedWidth: CroppedAreaImageWidthPixels,
            fullHeight: FullPanoHeightPixels,
            croppedHeight: CroppedAreaImageHeightPixels,
            topPixels: CroppedAreaTopPixels,
            heading: PoseHeadingDegrees,
            posePitchDegrees: PosePitchDegrees,
            poseRollDegrees: PoseRollDegrees
        };
    }

    onAutoTuneScreenshot(data, canvasWidth, canvasHeight){
        return updateWithMagick(data, ["convert", "eyespy360.png", '-auto-gamma', '-sigmoidal-contrast', '3,30%', '-channel', 'RGB', 'out3.png'])
            .then((data) => {
                this._fireEvent('screenshot', data, canvasWidth * 4, canvasHeight * 4);
                this._onScreenshotDone();
            })
            .catch((e) => {
                this._onScreenshotDone();
            })
    }

    _recalculateAdjustPoints() {
        let vertices = this._floorplan.getVerticesSpherCoords();
        let last = vertices.length - 1;
        this._adjustPoints.coords = [];
        vertices.reduce((p1, p2) => {
            if (!p1) return p2;
            let {poseRoll, posePitch} = this._floorplan.getPoseData()
            let adjustPointBottom = FloorplanManager.getSpherCenter(p2[0], p1[0], poseRoll, posePitch);
            let adjustPointTop = FloorplanManager.getSpherCenter(p2[1], p1[1], poseRoll, posePitch);
            this._adjustPoints.coords.push([adjustPointBottom,adjustPointTop]);

            return p2;
        }, this._floorplan.isDrawingFinished() ? vertices[last] : null);
    }

    _render(screenshotFormat) {
        super._render(screenshotFormat);
        if(this._loaded && this._floorEditorMode) {
            this._renderFloorplanPoints();
        }

        this._fireEvent('render', screenshotFormat);
    }

    _renderFloorplanPoints() {
        if (this._floorplan.getVertexCount() > 3) {
            this._floorplan.getVerticesSpherCoords().forEach((coords, i) => {
                this._renderHotSpotElement(...coords[0].map(c=>c/Pannellum.RADIAN), this._floorpoints[i][0], undefined, 'floorPoint');
                this._renderHotSpotElement(...coords[1].map(c=>c/Pannellum.RADIAN), this._floorpoints[i][1], undefined, 'floorPoint');

                if (this._adjustPoints.coords[i] && this._adjustPoints.elements[i]) {
                    this._renderHotSpotElement(...this._adjustPoints.coords[i][0].map(c=>c/Pannellum.RADIAN), this._adjustPoints.elements[i][0], undefined, 'floorPoint');
                    this._renderHotSpotElement(...this._adjustPoints.coords[i][1].map(c=>c/Pannellum.RADIAN), this._adjustPoints.elements[i][1], undefined, 'floorPoint');
                }
            });
        } else {
            this._floorplan.getVerticesSpherCoords().forEach((coords, i) => {
                this._renderHotSpotElement(...coords[0].map(c=>c/Pannellum.RADIAN), this._floorpoints[i][0], undefined, 'floorPoint');
                this._renderHotSpotElement(...coords[1].map(c=>c/Pannellum.RADIAN), this._floorpoints[i][1], undefined, 'floorPoint');
            });
        }
    }

    _renderInteracting(yaw, pitch, classname) {
        this._floorplan.addPoint([yaw, pitch]);
        this._floorpoints.push(this._createPoints(classname));
        if(this._floorplan.getVertexCount() > 1){
            let pairs = this._floorplan.getVerticesSpherCoords().filter((p,i,arr) => arr.length - i <= 2);
            this._addAdjusmentPointPair(pairs);
        }
    }

    adjustColor(id, filters) {
        this._renderer.adjustColor(filters);
        this._render();
    }

    canAddPoint() {
        return this._floorplan.canAddPoint();
    }

    clearArea() {
        this.isDrawingFinished = true;
        this._floorEditorMode = false;
        // this._updateCustomUpdateField(false);
        this._floorplan.clearArea();
        this._destroyFloorplanPoints();
        if(!this._floorplan.isPreviewCustomUpdate()) this._floorplan.closePath();
        this._floorEditorMode = true;
        this._render();
    }

    clearPoints(update=true){
        this.isDrawingFinished = true;
        this._floorEditorMode = false;
        this._updateCustomUpdateField(!update);
        this._destroyFloorplanPoints();
        this._floorplan.closePath(update);
        this._floorEditorMode = true;
        this._render();
    }

    isActiveArea(areaID){
        return this._floorplan.isActiveArea(areaID);
    }

    isCurrentArea(layerID, areaID){
        return this._floorplan.isCurrentArea(layerID, areaID);
    }

    changeFloors(obj){
        this._floorplan.changeFloors(obj);
    }

    deleteHole(id){
        this._unSelectHole();
        this._updateCustomUpdateField(true);
        this._floorplan.removeHole(id);
    }

    deleteLayer(id){
        let floors = this._floorplan.getFloors();
        let currentIndex = floors.findIndex(floor => floor.id === id);
        let newIndex = floors.length > 1
            ? currentIndex
                ? currentIndex - 1
                : currentIndex + 1
            : null;

        if (newIndex !== null) {
            // this._floorplan.removeLayerWithoutContent(id, floors[newIndex].id);
            this._floorplan.removeLayerWithContent(id, floors[newIndex].id);
        } else {
            this._floorplan.renameCurrentFloor('Floor Name');
        }
    }

    disableStateListening() {
        this._stateListening = false;
        this._enableHotspotsDrag();
        this._current.hotSpots
            .filter(hs => hs.type === 'info')
            .forEach(hs => hs.div.classList.remove('disabled'));
    }

    enableStateListening() {
        this._stateListening = true;
        this._disableHotspotsDrag();
        this._current.hotSpots
            .filter(hs => hs.type === 'info')
            .forEach(hs => hs.div.classList.add('disabled'));
    }

    getCurrentFloor() {
        return this._floorplan.getCurrentFloor();
    }

    // getFloorPlan(floor) {
    //     return this._floorplan.getFloorplanLayer(floor);
    // }

    getFloornames() {
        return this._floorplan.getFloors();
    }

    getFloorplanDetails() {
        return this._floorplan.getSceneProps();
    }

    getPlan() {
        return this._floorplan.getFloorplan();
    }

    getPlanPreview() {
        return this._floorplan.getFloorplanPreview();
    }

    setPlanPreview(plan) {
        this._floorplan.setFloorplanPreview(plan)
    }

    getVertexCount() {
        return this._floorplan.getVertexCount();
    }

    isFindingOffset() {
        return this._xmp;
    }

    get isDrawingFinished() {
        return this._drawing;
    }

    set isDrawingFinished(status) {
        return this._drawing = status;
    }

    // recalculateAdjustPoints() {
    //     this._floorplan.applyAdjustPoints();
    //     this._recalculateAdjustPoints();
    // }

    resetFloorplan() {
        this.recreateFloorplan(true)
            .then(() => {
                this._floorplan.updatePreview();
                this._fireEvent('preview');
            });
    }

    requestFloorpoint(enable) {
        this._waitingFloorpoint = enable;

        if(!enable) {
            this._floorplan.removeGhostPoint();
            requestAnimationFrame(this._animateBound);
        }

        this._xmp = true;
    }

    changeFloorplanParams(params) {
        this._floorplan.changeFloorplanParams(params);
    }

    updateSceneProperties(data) {
        this._updateCustomUpdateField(true);
        this._floorplan.updateSceneProperties(data);
    }

    updateCurrentFontSize(data) {
        this._updateCustomUpdateField(true);
        this._floorplan.updateCurrentFontSize(data);
    }

    _changeFontSizeLayer(data) {
        this._updateCustomUpdateField(true);
        this._floorplan._changeFontSizeLayer(data);
    }

    updateCurrentColor(patternColor, areaId) {
        this._updateCustomUpdateField(true);
        this._floorplan.updateCurrentColor(patternColor, areaId);
    }

    updatePolygonSize(poligonSize) {
        this._updateCustomUpdateField(true);
        this._floorplan.updatePolygonSize(poligonSize);
    }

    setCurrentFloorName(name, id) {
        this._floorplan.renameCurrentFloor(name, id);
    }

    setCurrentFloorAltitude(value, id) {
        this._floorplan.setCurrentFloorAltitude(value, id);
    }

    getNewFloorAltitude(prevFloorId) {
        return this._floorplan.getNewFloorAltitude(prevFloorId);
    }

    selectLayer(id) {
        this._floorplan.selectLayer(id);
    }

    setFloor(floor) {
        // this._updateCustomUpdateField(false);

        this._floorplan.setFloor(floor);

    }

    setFloorplanDetail(detail) {
        const {onchange} = detail;
        delete detail.onchange;

        this._floorplan.setCurrentSceneProps(detail, onchange);
        this._recalculateAdjustPoints();

        if(onchange){
            this._floorplan.closePath();
            this._floorplan.setAllScenesProps(detail);
            this.updateFloorplan(this._getFloorplanWithPreview());
        }

        this._render();
    }

    toggleFloorEditorMode(enable) {
        if(this._floorEditorMode !== enable) {
            this._floorEditorMode = enable;
            if(this._floorEditorMode) {
                this._createFloorplanPoints();
            }
            else {
                this._destroyFloorplanPoints();
                this._fireEvent('floorplan.panel.hide');
            }
        }
        this._render();
    }

    toggleFloorplanSnap(mode) {
        this._floorplan.toggleSnapMode(mode);
    }

    getLayerId() {
        return this._floorplan.getLayerId();
    }

    isNeedUpdateScene() {
        return this._floorplan.getSceneId() !== this._current.id;

    }

    updateFloorplan(plan = this._getFloorplanWithPreview()) {
        this._destroyFloorplanPoints();
        if (plan){
            this._initFloorplan(plan);
        }
        let [posePitch, poseRoll] = this._setCameraCorrection();
        this._floorplan.setRoom(this._current.sceneId, this._current.name, this._current.hotSpots
            .filter((val) => val.type == "scene")
            .map(hs =>({
                id: hs.id,
                link: hs.sceneId,
                equiCoord: [hs.yaw, hs.pitch]
            })), poseRoll, posePitch);
        if(this._floorEditorMode) this._createFloorplanPoints();
        this.updatePitchRatio();
        this._floorplan.updateScene(this._initialConfig.scenes);
        this._floorplan.updateScenePreview(this._initialConfig.scenes);
        this._render();
    }

    updatePitchRatio(){
        if(!this._imageData.layout_json || this._floorplan.getVertexCount() !== 0) return ;

        const layout = JSON.parse(this._imageData.layout_json);
        const pairs = layout.uv
            .map(p => ([FloorplanManager.xToYaw(p[0]), FloorplanManager.yToPitch(p[1])]))
            .reduce(function(result, value, index, array) {
                if (index % 2 === 0)
                    result.push(array.slice(index, index + 2));
                return result;
            }, []);

        pairs.forEach((coords) => {
            const [coord0, coord1] = coords;
            const [yaw0, pitch0] = coord0;
            const [yaw1, pitch1] = coord1;
            const pitchRatios = [];

            if(pitch0 > 0){
                pitchRatios.push(pitch0/-pitch1)
            }else{
                pitchRatios.push(-pitch0/pitch1)
            }

            let total = 0;
            for(let i = 0; i < pitchRatios.length; i++) {
                total += pitchRatios[i];
            }
            let avg = total / pitchRatios.length;

            this._floorplan.setPitchRatio(avg);
        })
    }

    updateSceneFilter(id, filters) {
        this._initialConfig.scenes[id].filters = filters;
    }

    changeHotSpotData(hsId, htmlID, options = {}) {
        let hs = this._current.hotSpots.find((_hs) => _hs.id === hsId);
        let hsIcon = hs.icon;
        let hsHtmlURL = hs.htmlURL;

        this._destroyHotSpotEvents(hs);

        hs = Object.assign(hs, options);
        hs.htmlURL = hsHtmlURL.split('/poi/')[0] + '/poi/' + htmlID;
        updateInfoIconStyle();

        this._initHotspotEvents(hs);
        const oldImg = hs.div.querySelector('.icon-img');
        if(oldImg){
            hs.div.removeChild(oldImg);
        }

        hs.div.classList.remove(`icon-${hsIcon}`);
        hs.div.classList.remove(`icon-default`);
        hs.div.classList.add(`icon-custom`);

        if(arrI.includes(hs.icon)) hs.div.classList.add(`icon-default`);

        const content = `content: url('${getIcon(hs.icon)}')`;
        const imgBlock = document.createElement('div');
        imgBlock.classList.add('icon-img');

        const img = document.createElement('img');
              // img.style = content;
              img.src = getIcon(hs.icon);

        updateInfoIconStyle(content, hsId);
        imgBlock.appendChild(img);

        if (options.title) {
            let span = document.createElement('span');
            span.className = 'pnlm-hotspot-title';
            span.innerHTML = options.title ? this._escapeHTML(options.title) : '';
            imgBlock.appendChild(span);
        }

        hs.div.appendChild(imgBlock);
    }
}

if(blur) {
    Object.assign(PannellumAdmin.prototype, BlurAdmin);
}

Object.assign(PannellumAdmin.prototype, RenderZoneAdmin);

export default PannellumAdmin;